import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class RenewService {
  
  private lineServiceUrl: string = environment.endpointBackend + '/api/line';

  constructor(private http: HttpClient) { }

  pushFlexMessageRenew(payload): Observable<any> {
    console.log("url => ",this.lineServiceUrl + '/pushFlexMessageRenew')
    console.log("payload => ",payload)
    return this.http.post<any>(this.lineServiceUrl + '/pushFlexMessageRenew', payload).pipe(
      map(
        response => {
          console.log("response =>",response)
          switch (response.response_code) {
            case ('40000'):
              return response
            default:
              return null
          }
        }
      )
    )
  }

}
